import {
  getLocalTime,
  TimeQuestionConfig,
  TimeResponseState,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import {
  RoutineQuestionMessage,
  RoutineQuestionMessageProps,
} from '../../types';

export const StartEndTimeMessage: RoutineQuestionMessage<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionMessageProps<TimeQuestionConfig, TimeResponseState>
) => {
  const { response } = props;
  const { t } = useTranslation();
  const start = response.timeTypeValue?.startTime
    ? getLocalTime(response.timeTypeValue.startTime)
    : '-';
  const end = response.timeTypeValue?.endTime
    ? getLocalTime(response.timeTypeValue.endTime)
    : '-';

  return (
    <View>
      <Text style={props.textStyle}>
        {t('routines.time.message.start')}: {start}
      </Text>
      <Text style={props.textStyle}>
        {t('routines.time.message.end')}: {end}
      </Text>
    </View>
  );
};
